<template>
  <div
  class="FilesDashboardRecent scrollbar-container"
  id="FilesDashboardRecentScrollable">
    <FilesBar
    v-if="files.length"
    :showRecent="true"
    class="FilesDashboardRecent__bar"/>
    <NoFilesPage v-if="empty"/>
    <transition-group
    tag="div"
    appear
    name="from-right-to-left"
    mode="out-in">
      <div
      v-for="(file, index) in files"
      :key="file.id"
      class="FilesDashboardRecent__element">
        <div
        v-if="isFirstInMonth(index)"
        class="FilesDashboardRecent__date">
          {{ fileUpdateMonth(file) }}
        </div>
        <FileBar
        :file='file'/>
      </div>
    </transition-group>
    <InViewportContainer
    v-if="hasNextToken"
    container-id="FilesDashboardRecentScrollable"
    :handler="getRecentFiles"
    class="FilesDashboardRecent__load-more">
      <i class="el-icon-loading FilesDashboardRecent__load-icon"/>
    </InViewportContainer>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

import FilesBar from '@/components/files/bar/FilesBar'
import FileBar from '@/components/file/bar/FileBar'

export default {
  name: 'FilesDashboardRecent',

  components: {
    FilesBar,
    FileBar
  },

  computed: {
    ...mapGetters('filesRecent', [
      'recentFiles',
      'recentBusy',
      'hasNextToken'
    ]),
    files () {
      return this.recentFiles.slice(0).sort((f1, f2) => {
        return f1.updatedAtMillis < f2.updatedAtMillis ? 1 : -1
      })
    },
    empty () {
      return !this.recentFiles.length && !this.recentBusy
    }
  },

  mounted () {
    this.getRecentFiles(true)
  },

  methods: {
    ...mapActions('filesRecent', [
      'clearRecentFiles',
      'getRecentFiles'
    ]),
    isFirstInMonth (index) {
      const previousFile = this.files[index - 1]
      if (!previousFile) return true

      const previousDate = new Date(previousFile.updatedAtMillis)
      const currentDate = new Date(this.files[index].updatedAtMillis)

      return currentDate.getMonth() - previousDate.getMonth() +
        (12 * (currentDate.getFullYear() - previousDate.getFullYear()))
    },
    fileUpdateMonth (file) {
      const options = {
        month: 'long',
        year: 'numeric'
      }
      let date = new Date(file.updatedAtMillis)

      return date.toLocaleString('en-GB', options)
    }
  }
}
</script>

<style lang="scss">
@import 'FilesDashboardRecent';
</style>
